<template v-if="singlePoc">
 <div class="border d-flex flex-column rounded-bottom-10 rounded-top-10 h-100 " >
        <a :href="[realUrl]" class="position-relative brand-poc-card-img"  v-if="displayImage">
            <img class="rounded-top-10 w-100" v-if="singlePoc.teaserImage" :src="singlePoc.teaserImage" />
            <img class="rounded-top-10 w-100" v-if="!singlePoc.teaserImage" src="/wp-content/themes/understrap-child/reader-web-app-angular/assets/images/loading_Image_top_image.svg" />
        </a>

         <a :href="[realUrl]" class="position-relative brand-poc-card-img rounded-top-10" v-if="!displayImage"  :style="{ background: singlePoc.parentColorHexCode }">
            <img class="rounded-top-10 w-100" v-if="singlePoc.parentLogo" :src="singlePoc.parentLogo" />
            <img class="rounded-top-10 w-100" v-if="!singlePoc.parentLogo" src="/wp-content/themes/understrap-child/reader-web-app-angular/assets/images/loading_Image_top_image.svg" />

        </a>
        <div class="card-body px-2 poc-card-body-h d-flex flex-column pb-1 justify-content-between">
            <!-- parent logo and Name  and poc type-->
            <div class="d-flex justify-content-between flex-wrap">
            <div class="d-flex justify-content-between w-100 min-h-28-p">
                <div class="parent-logo-wrapper mt-1 d-flex align-items-center">
                  <img class="parent-logo rounded-sm" :style="{ backgroundColor: singlePoc.parentColorHexCode}" v-if="singlePoc.parentLogo" :src="singlePoc.parentLogo" />
                  <p v-if="singlePoc.parentName" class="m-0 font-weight-bold">{{cuteventName(singlePoc.parentName)}}</p>
                </div>
                <div v-if="singlePoc.parentColorHexCode && (singlePoc.type || singlePoc.language)" class="d-flex mt-1">
                  <div v-if="singlePoc.type"  
                  :style="{ backgroundColor: singlePoc.parentColorHexCode}" class="d-flex px-1 rounded align-items-center">
                  <p class="sm--text-poc small m-0 text-white p-0" v-if="singlePoc.parentGenre">{{singlePoc.parentGenre}}</p>
                  </div>
                  <div v-if="singlePoc.language" class="ml-2 d-flex px-1 rounded align-items-center" :style="{ background: singlePoc.parentColorHexCode }">
                      <p class="sm--text-poc small m-0 text-white p-0">{{singlePoc.language}}</p>
                  </div>
                </div>
            </div>
            <a class="position-relative brand-poc-card-img">
                <h4 class="font-weight-bold my-3 w-100 single-poc-t-mh h5 text-dark text-break" v-if="singlePoc.title">{{singlePoc.title}}</h4>
            </a>
            </div>
            <div class="mb-3">
            <p v-if="singlePoc.subtitle" class="h6">
                {{singlePoc.subtitle}}
            </p>
            <div class="d-flex flex-wrap text-black-50 poc-expert-font-s-f poc-small-text">
                <template v-if="singlePoc.expertNames && singlePoc.expertNames.length">
                <span>By&nbsp;</span>
                <div class="flex-shrink-0" v-for="(expert, index) in singlePoc.expertNames.slice(0,2)" :key="index"  >
                    <div v-if="expert">{{expert}}<span v-if="singlePoc.expertNames.length > 1 && !last">,&nbsp;</span></div>
                </div>
                <div class="flex-shrink-0" v-if="singlePoc.expertNames && singlePoc.expertNames.length > 1">&nbsp;and more</div>
                </template>
            </div>
            <div class="d-flex justify-content-between mt-1 align-items-center">
                <div v-if="singlePoc.duration && singlePoc.duration > 60">
                    <span :style="{ color: singlePoc.parentColorHexCode }" class="poc-small-text">{{Math.floor(singlePoc.duration/60)}} min read</span>
                </div>
                <div v-if="!isReadContent && displayDateTime && !singlePoc.duration && singlePoc.parentColorHexCode" :style="{ color: singlePoc.parentColorHexCode }"  class="poc-small-text">{{displayDateTime}}</div>
            </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment';

export default {
  name: "singlePoc",
  created() {
    // console.log("singlePoc", this.singlePoc);
  },
  data() {
    return {
      displayImage: false,
      isReadContent: false,
      displayDateTime: null,
      bgColor: '#007d8d',
    };
  },
  props: {
    singlePoc: Object,
    realUrl: String,
  },
  mounted() {
    this.setImageForPoc();
    this.formatDates();
  },
  methods: {
    formatDates() {
      if (this.singlePoc && this.singlePoc.isReadContent) {
        this.isReadContent = true;
      }else{
        if(!this.isReadContent && this.singlePoc.startDate && this.singlePoc.endDate && 
          moment(this.singlePoc.startDate, 'DD-MM-YYYY HH:mm:ss').isValid() && moment(this.singlePoc.endDate, 'DD-MM-YYYY HH:mm:ss').isValid()){
          this.displayDateTime = moment(this.singlePoc.startDate, 'DD-MM-YYYY HH:mm:ss', 'DE').format('LL') + ' | ' + moment(this.singlePoc.startDate, 'DD-MM-YYYY HH:mm:ss', 'DE').format('LT') + ' - ' + moment(this.singlePoc.endDate, 'DD-MM-YYYY HH:mm:ss', 'DE').format('LT');
        }
      }
      if (this.singlePoc.parentColorHexCode) {
        this.bgColor = this.singlePoc.parentColorHexCode;
      }
    },

    setImageForPoc(){
      if (this.singlePoc.schemaType) {
        if (this.singlePoc.teaserImage) {
          this.displayImage = true;
          }else{
            if (this.singlePoc.schemaType == 'LESSON' && this.singlePoc.parentLogo) {
              this.displayImage = false;
            }else{
              this.displayImage = true;
          }
        }
      }
    },

    cuteventName(eventName){
      if(eventName && eventName.length > 24){
        eventName = eventName.slice(0,24) + "...";
      }
      return  eventName;
    }
    
  },
};
</script>

<style lang="css" scoped>

.brand-poc-card-img img{
    height: 175px;
    width: 100%;
}

.poc-card-body-h{
    min-height: 184px;
    width: 100%;
}

.parent-logo-wrapper img{
        width: 17px;
        height: 17px;
        flex-shrink: 0;
        margin-right: 5px;
        padding: 0.5px;

}

.parent-logo-wrapper p{
        font-size: 12px;    
  }

.poc-expert-font-s-f{
    font-size: 12px;
    font-family: sans-serif;
}

.live--svg{
    margin-left: 0.35rem;
}
.sm--text-poc{
    text-align: center;
    font-family: sans-serif;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.min-h-28-p{
    min-height: 28px;
}

.min-h-28-p div{
  height: 20px;
}

.single-poc-t-mh{
    min-height: 71px;
}

.poc-small-text{
    font-family: sans-serif;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}
.small{
    font-size: 7px;
}

</style>